export const syncTabWithUrl = (location, defaultTab, setActiveTab) => {
  const searchParams = new URLSearchParams(location.search);
  const tabFromUrl = searchParams.get("tab") || defaultTab;
  setActiveTab(tabFromUrl);
};
